const SOURCES = require('../utils/sources');
const {nameCreator, isCommittableByDefault, dataDecorator, processIds} = require('./item.decorators');

const getName = (data = {}, {name, category} = {}) => name || nameCreator[category](data);

const getDataDecorator = ({category} = {}) => dataDecorator[category] || ((data) => data);

const decorateData = (data = {}) => getDataDecorator(data)(data);

const getComposedItemData = (data = {}) => Object.assign({}, {
    name: getName(data, data),
}, decorateData(data));

const getArguments = (args) => [].slice.call(args);

const getIdProcessor = (category) => processIds[category];

const getIds = (category, ids = []) => ({name: ids.join('_'), ...getIdProcessor(category)(ids)});

class ItemBuilder {
    constructor(ShoppingCart, category) {
        this.cart = ShoppingCart;
        this.category = category;

        this.itemData = {
            price: {},
            committable: isCommittableByDefault[category] || false,
            source: {action: SOURCES.actions.USER_REQUESTED, target: SOURCES.targets.UNKNOWN},
        };
    }

    id(type, id) {
        Object.assign(this.itemData, getIds(this.category, getArguments(arguments)));

        return this;
    }

    from(action, target = SOURCES.targets.UNKNOWN) {
        if (action in SOURCES.actions && target in SOURCES.targets) {
            Object.assign(this.itemData, {source: {action, target}});
        }

        return this;
    }

    fromWidget() {
        return this.from(SOURCES.actions.USER_REQUESTED, SOURCES.targets.WIDGET);
    }

    fromPreselectedWidget() {
        return this.from(SOURCES.actions.PRESELECTED, SOURCES.targets.WIDGET);
    }

    fromContinueButton() {
        return this.from(SOURCES.actions.USER_REQUESTED, SOURCES.targets.CONTINUE_BUTTON);
    }

    fromAutomaticAddition() {
        return this.from(SOURCES.actions.AUTOMATICALLY_ADDED, SOURCES.targets.BUSINESS_LOGIC);
    }

    get toCommit() {
        Object.assign(this.itemData, {committable: true});
        return this;
    }

    get notToCommit() {
        Object.assign(this.itemData, {committable: false});
        return this;
    }

    get name() {
        return this.getComposedData().name;
    }

    getComposedData() {
        return getComposedItemData(Object.assign({}, this.itemData, {category: this.category}));
    }

    data(data = {}) {
        Object.assign(this.itemData, data);
        return this;
    }

    add() {
        this.cart.addProduct(this.getComposedData());
        return this;
    }

    toggle(selected = false) {
        this.cart.toggleProduct(this.getComposedData(), selected);
        return this;
    }

    remove() {
        if (this.cart.containsProduct(this.name)) {
            this.cart.removeProduct(this.name);
        }

        return this;
    }
}

module.exports = ItemBuilder;
